import SpriteSymbol from "../../../../node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/.pnpm/svg-sprite-loader@6.0.11/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "memberCenter-home_secondary",
  "use": "memberCenter-home_secondary-usage",
  "viewBox": "0 0 100 220",
  "content": "<symbol viewBox=\"0 0 100 220\" xmlns=\"http://www.w3.org/2000/svg\" id=\"memberCenter-home_secondary\"><path d=\"M0 23H100V111C100 116.523 95.5229 121 90 121H0V23Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol